(function(angular){
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('SignupCheckoutReviewOrder', [
			'$timeout',
			'$window',
			'CheckoutFactory',
			'globalConfig',
			SignupCheckoutReviewOrderFunction
		]);

	function SignupCheckoutReviewOrderFunction(
		$timeout,
		$window,
		CheckoutFactory,
		globalConfig){

		var reviewOrder = this;

		reviewOrder.placeOrderAndRedirect = function() {
			CheckoutFactory.placeOrder(buildPayload(), reviewOrder.orderGroupId)
				.then(function(data) {
					reviewOrder.reitInvestmentOrderGroupId = data.orderGroupId;
					$timeout(function() {
						submitForm();
					});
				})
				.catch(function() {
					reviewOrder.formSubmitted = false;
				});
		};

		function buildPayload() {
			var payload = {};

			if(angular.isDefined(reviewOrder.reitDocumentRevisionIds)) {
				payload.reitDocumentRevisionIds = reviewOrder.reitDocumentRevisionIds;
			}
			if(angular.isDefined(reviewOrder.addRecurringInvestmentSchedule)) {
				payload.addRecurringInvestmentSchedule = reviewOrder.addRecurringInvestmentSchedule;
			}
			if(angular.isDefined(reviewOrder.firstInvestmentDayOfMonth)) {
				payload.firstInvestmentDayOfMonth = reviewOrder.firstInvestmentDayOfMonth;
			}
			if(angular.isDefined(reviewOrder.frequency)) {
				payload.frequency = reviewOrder.frequency;
			}
			if(angular.isDefined(reviewOrder.recurringAmount)) {
				payload.recurringAmount = reviewOrder.recurringAmount;
			}
			if(angular.isDefined(reviewOrder.reinvestmentPreference)) {
				payload.reinvestmentPreference = reviewOrder.reinvestmentPreference;
			}

			return payload;
		}

		function submitForm() {
			$window.document.getElementById('reviewOrderForm').submit();
		}

		reviewOrder.$onInit = function() {
			angular.extend(reviewOrder, globalConfig);
		};
	}
})(window.angular);